/*
 * @Author: Chao Yang
 * @Date: 2020-05-06 10:42:26
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-07-25 21:53:26
 */
import { BaseProxy } from '../../base.proxy';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  IAccount,
  IConfiguration,
  IAccountBalance,
  IAccount2023,
} from 'src/app/domain/model/dashboard';
import { IInvestment } from 'src/app/domain/model/dashboard/investment/export/i-investment.model';
import { HttpParams } from '@angular/common/http';
import * as config from 'src/app/domain/model/configuration';
import * as IDtoAccountGroup from 'src/app/domain/model/account-group/index';

@Injectable()
export class MyInvestmentProxy extends BaseProxy {
  constructor(_http: HttpClient, private datePipe: DatePipe) {
    super(_http);
  }

  GetMyInvestments(
    start: Date,
    end: Date,
    displayclosedaccounts: boolean,
    accounts: IDtoAccountGroup.IAccountItem[],
    viewDataForAllInvestors: boolean
  ): Observable<IAccount[]> {
    const params = new HttpParams({
      fromObject: {
        start: start
          ? this.datePipe.transform(start, 'yyyy-MM-dd') + ''
          : this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd') + '',
        end: end ? this.datePipe.transform(end, 'yyyy-MM-dd') + '' : '',
        displayclosedaccounts: displayclosedaccounts ? 'true' : 'false',
        viewDataForAllInvestors: viewDataForAllInvestors.toString(),
      },
    });
    return this._http.post<IAccount[]>(
      `/ip/api/dashboard/myinvestments?`,
      accounts,
      {
        params,
      }
    );
  }

  GetMyInvestmentsConfig() {
    return this._http.get<IConfiguration>(
      `/ip/api/dashboard/configuration/myinvestments`
    );
  }

  GetBalances(
    start: Date,
    end: Date,
    accounts: IDtoAccountGroup.IAccountItem[],
    viewDataForAllInvestors: boolean
  ) {
    const params = new HttpParams({
      fromObject: {
        start: start
          ? this.datePipe.transform(start, 'yyyy-MM-dd') + ''
          : this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd') + '',
        end: end ? this.datePipe.transform(end, 'yyyy-MM-dd') + '' : '',
        viewDataForAllInvestors: viewDataForAllInvestors.toString(),
      },
    });
    return this._http.post<IAccountBalance[]>(
      `/ip/api/dashboard/myinvestments/balances`,
      accounts,
      { params }
    );
  }

  GenerateExportUrl(
    investments: IInvestment[],
    start: Date,
    end: Date,
    accounts: IDtoAccountGroup.IAccountItem[],
    groupKey: number,
    viewDataForAllInvestors: boolean,
    type: number
  ) {
    const startStr = start
      ? this.datePipe.transform(start, 'yyyy-MM-dd') + ''
      : this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd') + '';
    const endStr = end ? this.datePipe.transform(end, 'yyyy-MM-dd') + '' : '';
    const url = `/ip/api/dashboard/myinvestments/export?start=${startStr}&end=${endStr}`;
    return this._http
      .post<string>(url, {
        investments,
        accountItems: accounts,
        groupKey,
        viewDataForAllInvestors,
        type
      })
      .pipe(
        map((r) => {
          return `/ip/api/dashboard/myinvestments/export?resourceId=${r}`;
        })
      );
  }

  UpdateMyInvestmentDisplayClosedAccounts(
    config: config.IConfiguration<boolean>
  ) {
    return this._http.put(
      `/ip/api/dashboard/configuration/myinvestments/displayclosedaccounts`,
      config
    );
  }

  GetMyDealInvestments(
    start: Date,
    end: Date,
    displayclosedaccounts: boolean,
    accounts: IDtoAccountGroup.IAccountItem[],
    viewDataForAllInvestors: boolean,
    dealId: number
  ): Observable<IAccount[]> {
    const params = new HttpParams({
      fromObject: {
        start: start
          ? this.datePipe.transform(start, 'yyyy-MM-dd') + ''
          : this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd') + '',
        end: end ? this.datePipe.transform(end, 'yyyy-MM-dd') + '' : '',
        displayclosedaccounts: displayclosedaccounts ? 'true' : 'false',
        viewDataForAllInvestors: viewDataForAllInvestors.toString(),
        dealId: dealId.toString(),
      },
    });
    return this._http.post<IAccount[]>(
      `/ip/api/dashboard/myinvestments/deal?`,
      accounts,
      {
        params,
      }
    );
  }

  GetMyInvestments2023(
    start: Date,
    end: Date,
    displayClosedAccounts: boolean,
    accounts: IDtoAccountGroup.IAccountItem[],
    viewDataForAllInvestors: boolean
  ) {
    var startStr = this.getDateStr(start || new Date(2000, 0, 1)),
      endStr = this.getDateStr(end);
    return this._http
      .post<IAccount2023[]>(
        `/ip/api/dashboard/myinvestments/2023?start=${startStr}&end=${endStr}&viewDataForAllInvestors=${viewDataForAllInvestors}&displayClosedAccounts=${displayClosedAccounts}`,
        accounts
      )
      .pipe(
        map((data) => {
          data.forEach((item) => {
            if (item.layout.lastModificationTimeDataLayout) {
              item.layout.lastModificationTimeDataLayout = new Date(
                item.layout.lastModificationTimeDataLayout
              );
            }

            if (item.layout.lastModificationTimeDocumentLayout) {
              item.layout.lastModificationTimeDocumentLayout = new Date(
                item.layout.lastModificationTimeDocumentLayout
              );
            }

            if (item.layout.layout) {
              item.layout.layout = JSON.parse(item.layout.layout);
            }
          });
          return data;
        })
      );
  }
}
